import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

/**
 * Uplifted from `hooks/useOnlineStatus.ts` — **byte-identical in both apps** (verified with
 * `diff`), so the body lives here and both variants re-export it (standing rule 4).
 *
 * Reads `state.localServer.networkStatus`, which `redux-store/slices/LocalServerSlice` owns on
 * both platforms. This is `useSelector`, NOT a direct store import — nothing is read at module
 * eval time, so audit checks H/I/J are unaffected.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(true),
    networkStatus = useSelector((state: any) => state.localServer.networkStatus);

  useEffect(() => {
    setNetwork();
  }, []);

  useEffect(() => {
    setNetwork();
  }, [networkStatus]);

  function setNetwork() {
    let status = (networkStatus === "online");
    setIsOnline(status);
  }

  return isOnline;
}
